import React, { useEffect, useRef } from "react";
import FunnelLayout from "../FunnelLayout";
import { useFunnelForm } from "../useFunnelForm";
import { completeLead } from "../api";

function BigCheckIcon({ size = 48 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function SparkleIcon({ size = 14 }) {
  return (
    <svg viewBox="0 0 12 12" width={size} height={size} aria-hidden="true">
      <path
        d="M6 0L7.2 4.8L12 6L7.2 7.2L6 12L4.8 7.2L0 6L4.8 4.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

function HeadsetIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 14v-2a8 8 0 0116 0v2" />
      <rect x="3" y="14" width="4" height="6" rx="1.2" />
      <rect x="17" y="14" width="4" height="6" rx="1.2" />
      <path d="M21 18v1a2 2 0 01-2 2h-3" />
    </svg>
  );
}

function PhoneIcon({ size = 20 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z" />
    </svg>
  );
}

function ClipboardCheckIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="6" y="4" width="12" height="17" rx="2" />
      <path d="M9 4V3a1 1 0 011-1h4a1 1 0 011 1v1" />
      <polyline points="9 13 11 15 15 11" />
    </svg>
  );
}

function ShieldCheckIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  );
}

function CurvedArrowIcon() {
  return (
    <svg viewBox="0 0 36 32" width="40" height="32" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 22 C 4 8, 16 6, 28 16" />
      <polyline points="22 12 28 16 25 22" />
    </svg>
  );
}

function LockIcon({ size = 14 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}

function FemaleAgentAvatar() {
  return (
    <svg
      className="fv2-step6-agent-svg"
      viewBox="0 0 120 120"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="60" cy="60" r="54" fill="#dcfce7" />
      <path d="M22 112c0-22 17-34 38-34s38 12 38 34" fill="#1e3a8a" />
      <path d="M48 84l12 8 12-8" stroke="#ffffff" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="60" cy="56" r="20" fill="#fde9d4" />
      <path
        d="M40 50c0-12 9-22 20-22s20 10 20 22c0 3-1 6-2 8-2-6-6-9-12-9-5 0-8 3-8 7 0-4-3-7-8-7-6 0-10 3-12 9-1-2-2-5-2-8z"
        fill="#3d2817"
      />
      <path
        d="M38 56c-1 4 0 8 2 11l3-3c-2-2-3-5-3-8h-2z"
        fill="#3d2817"
      />
      <path
        d="M82 56c1 4 0 8-2 11l-3-3c2-2 3-5 3-8h2z"
        fill="#3d2817"
      />
      <circle cx="53" cy="58" r="1.5" fill="#1e3a8a" />
      <circle cx="67" cy="58" r="1.5" fill="#1e3a8a" />
      <path
        d="M54 66c2 3 4 4 6 4s4-1 6-4"
        stroke="#1e3a8a"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M38 56c0-12 10-20 22-20s22 8 22 20"
        stroke="#059669"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <ellipse cx="37" cy="56" rx="4" ry="5" fill="#059669" />
      <ellipse cx="83" cy="56" rx="4" ry="5" fill="#059669" />
      <path
        d="M83 60 Q 84 68 76 71"
        stroke="#059669"
        strokeWidth="2.4"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="76" cy="72" r="2.4" fill="#059669" />
      <circle cx="98" cy="98" r="11" fill="#059669" stroke="#ffffff" strokeWidth="2.4" />
      <polyline
        points="93 98 97 102 103 95"
        stroke="#ffffff"
        strokeWidth="2.2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FamilyIllustration() {
  return (
    <svg
      className="fv2-step6-family-svg"
      viewBox="0 0 150 80"
      fill="none"
      aria-hidden="true"
    >
      <ellipse cx="75" cy="70" rx="70" ry="6" fill="#cfdaf0" opacity="0.55" />

      <circle cx="30" cy="40" r="22" fill="#dbeafe" />
      <path d="M12 70c0-10 8-16 18-16s18 6 18 16v4H12z" fill="#1e3a8a" />
      <circle cx="30" cy="36" r="9" fill="#fde9d4" />
      <path
        d="M21 33c0-6 4-10 9-10s9 4 9 10c0 2-1 3-2 4-1-3-3-5-7-5-3 0-5 1-7 3-1-1-2-1-2-2z"
        fill="#3d2817"
      />
      <circle cx="27" cy="37" r="1" fill="#1e3a8a" />
      <circle cx="33" cy="37" r="1" fill="#1e3a8a" />
      <path
        d="M27 41c1 1 2 2 3 2s2-1 3-2"
        stroke="#1e3a8a"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
      />

      <circle cx="75" cy="48" r="18" fill="#bbf7d0" />
      <path d="M61 72c0-7 6-12 14-12s14 5 14 12v2H61z" fill="#047857" />
      <circle cx="75" cy="44" r="7" fill="#fde9d4" />
      <path
        d="M69 42c0-4 3-7 6-7s6 3 6 7c0 1 0 2-1 2-1-2-3-3-5-3-2 0-4 1-5 3-1 0-1-1-1-2z"
        fill="#a0522d"
      />
      <circle cx="73" cy="44" r="0.9" fill="#1e3a8a" />
      <circle cx="77" cy="44" r="0.9" fill="#1e3a8a" />
      <path
        d="M73 48c1 1 1 1 2 1s1 0 2-1"
        stroke="#1e3a8a"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
      />

      <circle cx="120" cy="40" r="22" fill="#dbeafe" />
      <path d="M102 70c0-10 8-16 18-16s18 6 18 16v4h-36z" fill="#1e3a8a" />
      <circle cx="120" cy="36" r="9" fill="#fde9d4" />
      <path
        d="M110 33c0-6 5-11 10-11s10 5 10 11c0 3-1 6-3 9l-2-2c-1-2 0-5-1-7-1-3-3-5-6-5-2 0-5 2-6 4-1 2 0 5-1 7l-1 2c-1-3 0-6 0-8z"
        fill="#3d2817"
      />
      <circle cx="117" cy="37" r="1" fill="#1e3a8a" />
      <circle cx="123" cy="37" r="1" fill="#1e3a8a" />
      <path
        d="M117 41c1 1 2 2 3 2s2-1 3-2"
        stroke="#1e3a8a"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

export default function Step6() {
  const { data, markCompleted } = useFunnelForm();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;

    if (!data.leadId) return; // nothing to complete
    if (data.leadId === data.lastCompletedLeadId) return; // this lead already completed

    markCompleted(data.leadId);

    completeLead(data.leadId, {
      step1: data.step1,
      step2: data.step2,
      step3: data.step3,
      step4: data.step4,
      createdAt: data.createdAt,
      tracking: data.tracking,
      pageUrl: window.location.href
    }).catch(() => {});
    // Mount-once: fire /complete exactly once per lead. The lastCompletedLeadId
    // guard lets it re-fire for a NEW lead but not on remount/refresh/back-nav.
  }, []);

  return (
    <FunnelLayout currentStep={6} complete>
      <div className="fv2-step6">
        <div className="fv2-step6-hero">
          <span className="fv2-step6-spark fv2-step6-spark-tl" aria-hidden="true">
            <SparkleIcon size={14} />
          </span>
          <span className="fv2-step6-spark fv2-step6-spark-tr" aria-hidden="true">
            <SparkleIcon size={10} />
          </span>
          <span className="fv2-step6-spark fv2-step6-spark-bl" aria-hidden="true">
            <SparkleIcon size={10} />
          </span>
          <span className="fv2-step6-spark fv2-step6-spark-br" aria-hidden="true">
            <SparkleIcon size={12} />
          </span>
          <div className="fv2-step6-hero-circle">
            <BigCheckIcon size={48} />
          </div>
        </div>

        <h1 className="fv2-step6-h1">You're All Set!</h1>
        <p className="fv2-step6-subh">Your best options are ready.</p>
        <p className="fv2-step6-body">
          A licensed insurance agent is reviewing your information now and will
          contact you shortly.
        </p>

        <div className="fv2-step6-connect">
          <div className="fv2-step6-connect-left">
            <span className="fv2-step6-connect-icon">
              <HeadsetIcon size={22} />
            </span>
            <div>
              <strong>We'll connect you with a licensed agent</strong>
              <p>
                They'll review your best-fit plans and help you choose the right
                coverage for your needs and budget.
              </p>
            </div>
          </div>
          <div className="fv2-step6-connect-right">
            <FemaleAgentAvatar />
          </div>
        </div>

        <h3 className="fv2-step6-whn">What happens next?</h3>

        <div className="fv2-step6-strip">
          <div className="fv2-step6-strip-card">
            <div className="fv2-step6-strip-icon">
              <PhoneIcon size={22} />
            </div>
            <strong>We call you</strong>
            <p>
              A licensed agent will call you at{" "}
              <span className="fv2-step6-phoneref">(833) 721-2356</span> within
              the next few minutes.
            </p>
          </div>

          <div className="fv2-step6-strip-card">
            <div className="fv2-step6-strip-icon">
              <ClipboardCheckIcon size={22} />
            </div>
            <strong>Review your options</strong>
            <p>
              We'll go over your top plan matches, benefits, and costs with you.
            </p>
          </div>

          <div className="fv2-step6-strip-card">
            <div className="fv2-step6-strip-icon">
              <ShieldCheckIcon size={22} />
            </div>
            <strong>Find the right fit</strong>
            <p>
              Get answers, compare plans, and choose the coverage that's right
              for you.
            </p>
          </div>
        </div>

        <div className="fv2-step6-talk">
          <div className="fv2-step6-talk-left">
            <span className="fv2-step6-talk-icon">
              <PhoneIcon size={22} />
            </span>
            <div>
              <strong>Talk to a licensed agent now</strong>
              <p>Skip the wait and get your questions answered right away.</p>
            </div>
          </div>
          <span className="fv2-step6-talk-arrow" aria-hidden="true">
            <CurvedArrowIcon />
          </span>
          <div className="fv2-step6-talk-right">
            <a className="fv2-step6-call-btn" href="tel:+18337212356">
              <PhoneIcon size={20} />
              (833) 721-2356
            </a>
            <span className="fv2-step6-tap-label">Tap to call now</span>
          </div>
        </div>

        <div className="fv2-step6-trust">
          <div className="fv2-step6-trust-left">
            <span className="fv2-step6-trust-icon">
              <ShieldCheckIcon size={24} />
            </span>
            <div className="fv2-step6-trust-text">
              <strong>You're in good hands.</strong>
              <p>
                Our licensed agents will help you find affordable, quality
                coverage that fits your needs.
              </p>
            </div>
          </div>
          <div className="fv2-step6-trust-right">
            <FamilyIllustration />
          </div>
        </div>

        <div className="fv2-step6-secfooter">
          <div className="fv2-step6-sec-item">
            <LockIcon />
            <span>Your information is secure and confidential.</span>
          </div>
          <div className="fv2-step6-sec-divider" aria-hidden="true" />
          <div className="fv2-step6-sec-item">
            <span>
              We <strong className="fv2-step6-sec-blue">never share</strong>{" "}
              your information.
            </span>
          </div>
        </div>
      </div>
    </FunnelLayout>
  );
}
